import { render, staticRenderFns } from "./ColSalvageInstallment.vue?vue&type=template&id=272fa1fa&scoped=true"
import script from "./ColSalvageInstallment.vue?vue&type=script&lang=js"
export * from "./ColSalvageInstallment.vue?vue&type=script&lang=js"
import style0 from "./ColSalvageInstallment.vue?vue&type=style&index=0&id=272fa1fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272fa1fa",
  null
  
)

export default component.exports